module.exports = __webpack_public_path__ + "pe-icon-set-weather.ea37c7a8deb1c2303b04.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/cricketmon/Sites/clubsandwichadmin/src/assets/fonts/pe/fonts/pe-icon-set-weather.ttf?nlruav
// module id = ../../../../../src/assets/fonts/pe/fonts/pe-icon-set-weather.ttf?nlruav
// module chunks = styles